import React from "react";
import { ArrowRight } from "lucide-react";
import { LABS_LABEL, LABS_URL } from "@/lib/suite";

export default function LabsLink({
  children,
  className = "",
  testid = "labs-link",
  arrow = false,
  ...rest
}) {
  return (
    <a
      href={LABS_URL}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
      data-testid={testid}
      {...rest}
    >
      {children || LABS_LABEL}
      {arrow && <ArrowRight className="h-3 w-3" />}
    </a>
  );
}
